import PropTypes from "prop-types"
import intl from "react-intl-universal"
import * as S from "./styled"

const Toggle = ({ onChangeIncluded, included }) => {
  return (
    <S.ToggleWrapper>
      <S.ToggleLabel>
        {intl.get("primaryMaterialScheduleList.arrivedLoads")}
      </S.ToggleLabel>
      <S.ToggleButton
        disabled={included}
        onClick={onChangeIncluded}
      >
        {intl.get("primaryMaterialScheduleList.included")}
      </S.ToggleButton>
      <S.ToggleButton
        disabled={!included}
        onClick={onChangeIncluded}
      >
        {intl.get("primaryMaterialScheduleList.notIncluded")}
      </S.ToggleButton>
    </S.ToggleWrapper>
  )
}

Toggle.propTypes = {
  included: PropTypes.any.isRequired,
  onChangeIncluded: PropTypes.any.isRequired
}

export default Toggle
